import { useEditor, EditorContent } from '@tiptap/react'
import StarterKit from '@tiptap/starter-kit'
import Link from '@tiptap/extension-link'
import Underline from '@tiptap/extension-underline'
import styles from './Tiptap.module.scss'
import { ReactComponent as HyperlinkIcon } from '../../assets/images/common/icons/hyperlink-icon.svg'
import { useEffect, useState } from 'react'
import LinkInputModal from './LinkInputModal'
import DOMPurify from 'dompurify'
import PropTypes from 'prop-types'
import classNames from 'classnames'

const Tiptap = ({ value, onChange }) => {
  const [linkModal, setLinkModal] = useState(false)
  const [initialUrl, setInitialUrl] = useState('')

  const editor = useEditor({
    extensions: [
      StarterKit,
      Link.configure({
        openOnClick: false,
        autolink: true,
        defaultProtocol: 'https',
        protocols: ['http', 'https'],
      }),
      Underline,
    ],
    content: value,
    onUpdate: ({ editor }) => {
      const rawHTML = editor.getHTML()
      const sanitized = DOMPurify.sanitize(rawHTML, {
        ADD_ATTR: ['target'],
      })
      onChange(sanitized)
    },
  })

  useEffect(() => {
    if (editor && value !== editor.getHTML()) {
      editor.commands.setContent(value, false)
    }
  }, [value, editor])

  const openLinkModal = () => {
    if (!editor) { return }
    const previousUrl = editor.getAttributes('link').href || ''
    setInitialUrl(previousUrl)
    setLinkModal(true)
  }

  const handleLinkInsert = (url) => {
    if (!editor) { return }

    if (url === '') {
      editor.chain().focus().extendMarkRange('link')
        .unsetLink()
        .run()
    } else {
      editor.chain().focus().extendMarkRange('link')
        .setLink({ href: url, target: '_blank' })
        .run()
    }
  }
  return (
    <div className={styles.container}>
      <EditorContent editor={editor} className={styles.editorWrapper}/>

      <div className={styles.toolbar}>
        <button
          onClick={() => editor.chain().focus().toggleBold()
            .run()}
          className={classNames({ [styles.active]: editor.isActive('bold') })}
          type='button'
        >
          B
        </button>
        <button
          onClick={() => editor.chain().focus().toggleItalic()
            .run()}
          className={classNames({ [styles.active]: editor.isActive('italic') })}

          type='button'
        >
          I
        </button>
        <button
          onClick={() => editor.chain().focus().toggleUnderline()
            .run()}
          className={classNames({ [styles.active]: editor.isActive('underline') })}
          type='button'
        >
          U
        </button>
        <button
          onClick={openLinkModal}
          className={classNames({ [styles.active]: editor.isActive('link') })}
          type='button'
        >
          <HyperlinkIcon />
        </button>
      </div>

      {editor && (
        <LinkInputModal
          isOpen={linkModal}
          onClose={() => setLinkModal(false)}
          onSubmit={handleLinkInsert}
          initialUrl={initialUrl}
        />
      )}
    </div>
  )
}

Tiptap.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
}

export default Tiptap
